'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dismissBotTypingIndicator = undefined;

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _stopBotTyping = require('./stopBotTyping');

var dismissBotTypingIndicator = exports.dismissBotTypingIndicator = function dismissBotTypingIndicator(message, threadId) {
  return function (dispatch) {
    var senderId = (0, _commonMessageFormatGetters.getSenderId)(message);

    dispatch((0, _stopBotTyping.stopBotTyping)(threadId, senderId));
  };
};